module.exports = __webpack_public_path__ + "e8e021aaa22e6bcf62d2997df691f4c5.svg";